import React from "react";
import { useSelector } from "react-redux";
import { DropdownItem } from "Components/ReactstrapSlim";
import { IHeaderMenuCountersViewModel } from "Services/API/API";
import { UserSelectorModel, brandingSelector } from "Utils/selectors";
import { HeaderMemberDropDownMenu } from "./HeaderMemberDropDownMenu";

interface HeaderEnterpriseAdminDropDownMenuProps {
   user: UserSelectorModel;
   headerMenuCounters: IHeaderMenuCountersViewModel;
   isEnterpriseManagment?: boolean,
}
export const HeaderEnterpriseAdminDropDownMenu: React.FC<HeaderEnterpriseAdminDropDownMenuProps> = ({ user, headerMenuCounters, isEnterpriseManagment }) => {
   const branding = useSelector(brandingSelector);
   return <div className="header-user-popup-va">
      <div className="header-user-popup-va-user">
         <HeaderMemberDropDownMenu user={user} headerMenuCounters={headerMenuCounters} isEnterpriseManagment={isEnterpriseManagment} />
      </div>
      <DropdownItem divider className="d-md-none" />
      <div className="header-user-popup-va-venues">
         <DropdownItem header>
            {branding?.name ?? "Enterprise"}
         </DropdownItem>
         <DropdownItem tag="a" href={"/enterprisemanagement/dashboard"}>Workplace Manager</DropdownItem>
         <DropdownItem tag="a" href={"/enterprisemanagement/members"}>Teams</DropdownItem>
         <DropdownItem tag="a" href={"/enterprisemanagement/activity/reservations"}>Activity</DropdownItem>
      </div>
   </div>;
};